import { ColumnsType } from 'antd/lib/table';
import { VendorInfoTourPackage } from '../../RefundTypes/RefundTypes';

export const TourRefundViewTableColumnClient = (): ColumnsType => {
  return [
    {
      title: 'Client Name',
      dataIndex: 'client_name',
      key: 'client_name',
    },
    {
      title: 'Type',
      dataIndex: 'payment_type',
      key: 'payment_type',
    },
    {
      title: 'Refund Charge',
      align: 'right',
      key: 'refund_charge',
      dataIndex: 'refund_charge',
    },
    {
      title: 'Refund Amount',
      align: 'right',
      key: 'refund_amount',
      dataIndex: 'refund_amount',
    },
  ];
};
export const TourRefundViewTableColumn = (): ColumnsType<VendorInfoTourPackage> => {
  return [
    {
      title: 'Vendor Name',
      dataIndex: 'vrefund_vendor_name',
      key: 'vrefund_vendor_name',
    },
    {
      title: 'Type',
      dataIndex: 'vrefund_payment_type',
      key: 'vrefund_payment_type',
    },
    {
      title: 'Refund Charge',
      align: 'right',
      key: 'vrefund_charge_amount',
      dataIndex: 'vrefund_charge_amount',
    },
    {
      title: 'Refund Amount',
      align: 'right',
      key: 'vrefund_return_amount',
      dataIndex: 'vrefund_return_amount',
    },
  ];
};
